<template>
  <div class="exchange-order-list-component">
    <div
      class="no-exchange-order"
      v-if="!list.length"
    >
      <div class="no-exchange-module">
        <img src="@/assets/images/order/no-exchange-order.png" />
        <p> 亲，您还没有订单哦！</p>
      </div>

    </div>
    <div
      class="exchange-order-list"
      v-else
    >
      <template v-for="(order, index) in list">
        <div
          class="exchange-order-item"
          :key="index"
        >
          <div class="exchange-order-header clearfix">
            <span class="fl">{{order.createDateTime | formatTime('y-m-d a h:i:s')}}</span>
            <span class="fr">订单号：{{order.orderCode}}</span>
          </div>
          <div
            class="exchange-order-content"
            v-for="(o, i) in order.eshopGoods"
            :key="i"
          >
            <div class="exchange-module clearfix">
              <div class="exchange-module-one fl">
                <img
                  class="goods-img fl"
                  :src="o.imgUrl"
                />
                <div class="exchange-goods fl">
                  <div class="goods-name">{{o.name}}</div>
                  <div class="goods-num">兑换：<img
                      class="currency-img"
                      src="@/assets/images/order/currency.png"
                    />{{o.eggshellNumber}}</div>
                  <span class="goods-count">{{o.count}}</span>
                </div>
              </div>
              <div class="exchange-module-two text-center fl">
                <span>应付金额</span>
                <span>￥0</span>
              </div>
              <div class="exchange-module-tree fl">
                <template v-if="o.goodsType === 'COURSE' || o.goodsType === 'DOUBLE_EXCELLENT_COURSE'">
                  <div class="name">兑换账户：{{order.studentName}}</div>
                  <div
                    class="exchange-btn-groups clearfix"
                    v-if="order.status === 'TO_BE_CONFIRMED'"
                  >
                    <span
                      class="fl exchang-btn"
                      @click="cancelExchange(order.orderCode)"
                    >取消兑换</span>
                    <span class="fl line"></span>
                    <span
                      class="fl exchang-btn"
                      @click="sureExchange(order, o)"
                    >确认订单</span>
                  </div>
                  <div
                    class="exchange-status"
                    v-else
                  >{{orderStatusMapForTypeCOURSE[order.status]}}</div>
                </template>
                <template v-else-if="o.goodsType === 'PET_PROP'">
                  <div class="name">兑换账户：{{order.studentName}}</div>
                  <div
                    class="exchange-btn-groups clearfix"
                    v-if="order.status === 'TO_BE_CONFIRMED'"
                  >
                    <span
                      class="fl exchang-btn"
                      @click="cancelExchange(order.orderCode)"
                    >取消兑换</span>
                    <span class="fl line"></span>
                    <span
                      class="fl exchang-btn"
                      @click="sureExchange(order, o)"
                    >确认兑换</span>
                  </div>
                  <div
                    class="exchange-status"
                    v-else
                  >{{orderStatusMapForTypePET_PROP[order.status]}}</div>
                </template>
                <template v-else>
                  <template v-if="order.status === 'TO_BE_CONFIRMED'">
                    <template v-if="order.receiverName && order.receiverPhone && order.receiverAddress">
                      <p clsss="address-module">
                        {{order.receiverName}}，{{order.receiverPhone}}，{{order.receiverAddress}}
                        <template v-if="order.zipcode">，{{order.zipcode}}</template>
                      </p>
                      <div class="exchange-btn-groups clearfix">
                        <span
                          class="fl exchang-btn"
                          @click="cancelExchange(order.orderCode)"
                        >取消兑换</span>
                        <span class="fl line"></span>
                        <span
                          class="fl exchang-btn"
                          @click="editAddress"
                        >编辑地址</span>
                        <span class="fl line"></span>
                        <span
                          class="fl exchang-btn"
                          @click="sureExchange(order, o)"
                        >确认订单及地址</span>
                      </div>
                    </template>
                    <template v-else>
                      <span
                        class="fl exchang-btn"
                        @click="editAddress"
                      >编辑收货地址</span>
                    </template>
                  </template>
                  <template v-else>
                    <div class="exchange-status">
                      <template v-if="order.status ==='CANCEL'">兑换已取消</template>
                      <template v-if="order.status ==='FAILED'">兑换失败</template>
                      <template v-if="order.status === 'INVALIDATION'">订单失效</template>
                      <template v-if="order.status ==='CONFIRMED'">
                        兑换成功
                        <p class="info">7-15个工作日发货，请耐心等待。</p>
                      </template>
                      <template v-if="order.status ==='DELIVERED'">
                        您兑换的物品已发货
                        <p class="info">
                          <span>快递公司：{{order.expressCompany}}</span>
                          <span>运单号码：{{order.expressNo}}</span>
                        </p>
                      </template>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>

    </div>

    <!-- 分页 -->
    <slot v-if="list.length"></slot>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {

  },
  data() {
    return {
      orderStatusMapForTypeCOURSE: {
        'TO_BE_CONFIRMED': '',
        'CANCEL': '充值已取消',
        'CONFIRMED': '充值成功',
        'DELIVERED': '充值中',
        'FAILED': '充值失败',
        'INVALIDATION': '订单失效'
      },
      orderStatusMapForTypePET_PROP: {
        'TO_BE_CONFIRMED': '',
        'CANCEL': '兑换已取消',
        'CONFIRMED': '兑换成功',
        'DELIVERED': '兑换中',
        'FAILED': '兑换失败',
        'INVALIDATION': '订单失效'
      }
    }
  },
  methods: {
    cancelExchange(orderCode) {
      this.$confirm({
        content: '确定取消宝贝兑换的礼品吗？',
        cancelBtnText: '再想想',
        sureBtnText: '确定取消'
      }).then(res => {
        this.axios({
          method: 'post',
          url: '/parentrest/api/pc/exchangeOrder/cancelEshopOrder',
          params: {
            orderCode,
            studentId: this.$cookies.get('studentId'),
            parentId: this.$cookies.get('parentId')
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.$emit('getExchangeOrderList')
          }
        })
      }).catch(err => { })
    },
    sureExchange(order, o) {
      this.$confirm({
        content: `确定兑换“${o.name}”吗? 一经兑换，不支持退换货`,
        cancelBtnText: '再想想',
        sureBtnText: '确定'
      }).then(res => {
        this.axios({
          method: 'post',
          url: '/parentrest/api/pc/exchangeOrder/confirmEshopOrder',
          params: {
            studentId: this.$cookies.get('studentId'),
            parentId: this.$cookies.get('parentId'),
            receiverName: order.receiverName,
            receiverPhone: order.receiverPhone,
            receiverAddress: order.receiverAddress,
            zipcode: order.zipcode,
            orderCode: order.orderCode
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.$emit('getExchangeOrderList')
          }
        })
      }).catch(err => { })
    },
    editAddress() {
      window.location.href = window.location.origin + '/parent/setting'
    }
  }
}
</script>

<style lang="less" scoped>
.exchange-order-list-component {
  .exchang-btn {
    &:hover {
      color: #f60;
      cursor: pointer;
    }
  }
  .no-exchange-order {
    text-align: center;
    .no-exchange-module {
      display: inline-block;
      margin: 50px auto 200px;
      p {
        margin-top: 20px;
        font-size: 18px;
        color: #b9b9b9;
      }
    }
  }
  .exchange-order-list {
    .exchange-order-item {
      border: 1px solid #e0e0e0;
      border-radius: 3px;
      overflow: hidden;
      margin-bottom: 15px;
      .exchange-order-header {
        height: 44px;
        line-height: 44px;
        background-color: #eee;
        padding: 0 20px;
        font-size: 12px;
      }
      .exchange-order-content {
        padding: 16px 20px;
        .exchange-module {
          .exchange-module-one {
            position: relative;
            .goods-img {
              height: 62px;
              width: 62px;
            }
            .currency-img {
              display: inline-block;
              height: 16px;
              width: 16px;
              margin-bottom: -4px;
              margin-right: 2px;
            }
            .exchange-goods {
              position: relative;
              width: 300px;
              padding: 6px 30px 0 12px;
              .goods-name {
                font-size: 14px;
                color: #333;
                height: 28px;
                line-height: 1;
                margin-bottom: 11px;
                margin-right: 20px;
              }
              .goods-num {
                font-size: 12px;
                color: #666;
              }
              .goods-count {
                display: inline-block;
                position: absolute;
                height: 24px;
                line-height: 24px;
                right: 30px;
                top: 50%;
                transform: translateY(-50%);
                padding-left: 11px;
                font-size: 14px;
                background: url("../../../../assets/images/order/bg.png")
                  no-repeat -123px -43px;
              }
            }
          }
          .exchange-module-two {
            position: relative;
            height: 62px;
            width: 160px;
            padding-top: 7px;
            span {
              display: block;
              font-size: 14px;
              height: 24px;
              line-height: 24px;
              &:first-child {
                color: #666;
              }
              &:last-child {
                color: #333;
                font-weight: 700;
              }
            }
          }
          .exchange-module-tree {
            padding-top: 4px;
            padding-left: 30px;
            font-size: 12px;
            width: 450px;
            .name {
              height: 16px;
              line-height: 16px;
            }
            span {
              display: inline-block;
              &.line {
                height: 12px;
                width: 0;
                font-size: 0;
                border-left: 1px solid #333;
                margin: 0 10px;
              }
            }
            .exchange-btn-groups {
              margin-top: 10px;
              line-height: 12px;
            }
            .exchange-status {
              color: #666;
              font-size: 14px;
              margin-top: 10px;
              .info {
                font-size: 12px;
                line-height: 16px;
                span {
                  font-size: 12px;
                  display: inline-block;
                  margin-right: 10px;
                }
              }
            }
            .address-module {
              word-wrap: break-word;
              //   word-break: normal;
              word-break: break-all;
            }
          }
          .exchange-module-one,
          .exchange-module-two {
            &::after {
              content: " ";
              position: absolute;
              right: 0;
              top: 50%;
              height: 40px;
              background-color: #e0e0e0;
              width: 1px;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }
}
</style>
